import { ReactElement, ReactNode } from "react";

import {
  GetNextPageParamFunction,
  GetPreviousPageParamFunction,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const getNextPage: GetNextPageParamFunction<any & Pagination> = ({
  page = 0,
  totalPages = 0,
}) => (page + 1 < totalPages ? page + 1 : undefined);
const getPrevPage: GetPreviousPageParamFunction<any & Pagination> = ({
  page = 0,
}) => (page > 0 ? page - 1 : undefined);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 300000, // 5 minutes to match cache time
      getNextPageParam: getNextPage,
      getPreviousPageParam: getPrevPage,
    },
  },
});

const ReactQueryProvider = ({
  children,
}: {
  children: ReactNode;
}): ReactElement => (
  <QueryClientProvider client={queryClient}>
    {children}
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
);

export default ReactQueryProvider;
